import { useEffect, useState } from "react";
import { getAuth, signOut } from "firebase/auth";
import useAuth from '../Auth/useAuth';
import moment from 'moment';
import 'moment/locale/es';
import { useParams } from "react-router-dom";
import axios from 'axios';
import './Foro.css';
import perfil from "../../assets/images/perfil.png";
import { Helmet } from 'react-helmet';
import logo from '../../assets/images/logo_radioital_blanco.png';
import SocialShare from "../Pages/SocialShare";

function getDia(num) {
  let meses = ["Domingo", "Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado" ];
  return meses[num];
}

const Foro = () => {
  const isAuth = useAuth();
  const id = useParams();
  const API_CMNT = 'https://radioital.com/api/public/api/comentario/';
  const API_FORO = 'https://radioital.com/api/public/api/foros/show/' + id.id;
  const [foro, setForo] = useState(null);
  const [mensaje, setMensaje] = useState('');
  const [respuestas, setRespuestas] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!mensaje.trim()) return;
    try {
      axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
      axios.defaults.headers.post['Content-Type'] = 'application/json';
      const res = await axios.get(API_CMNT + id.id + '/' + localStorage.getItem('uid') + '/' + localStorage.getItem('token') + '/' + mensaje, {
        headers: {
          'Content-Type': 'application/json',
        }
      });
      setRespuestas(res.data.ans);
      setMensaje('');
    } catch (error) {
      console.error('Error al enviar mensaje:', error);
    }
  };

  useEffect(() => {
    axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
    axios.defaults.headers.post['Content-Type'] = 'application/json';
    //datos del programa
    axios.get(API_FORO, {
      headers: {
        //'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        // 'Authorization': 'Bearer token' // si lo usas
      }
    })
      .then(function(res){
        setForo(res.data.data);
        setRespuestas(res.data.ans);
      });
    if(!localStorage.getItem('token')){
      const auth = getAuth();
      signOut(auth)
        .then(() => {
          console.log("Sesión cerrada");
          localStorage.clear();
          sessionStorage.clear();
        })
        .catch((error) => console.error("Error al cerrar sesión", error));
    }
  }, []);


  if (foro) {
    return (<>
      <Helmet>
        <title>{foro.ttlo_fro} Radioshow</title>
        <meta property="og:title" content={foro.ttlo_fro} />
        <meta property="og:description" content={foro.dscrpcn_fro} />
        <meta property="og:image" content={logo} />
        <meta property="og:url" content={"https://radioital.com/comunidad/"+foro.key_fro} />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <div className="foro">
        <h1>{foro.ttlo_fro}</h1>
        <div className="foro_comentarios">
          <h3>{foro.dscrpcn_fro}</h3>
          {console.log(respuestas)}
          {respuestas.length > 0 ? (
            <div className="body_comentarios">
              {respuestas ? ( respuestas.map((item, i) => (
                <div key={i} style={{ padding: '10px', border: '1px solid #ccc', marginBottom: '5px', display:"flex", flexDirection:"row", alignItems: "flex-start" }}>
                  <img src={perfil} alt="perfil radioital" style={{ borderRadius: '3em', width: '60px'}} />
                  <div style={{display:"flex", flexDirection:"column", margin: "0 0 0 0.5em"}}>
                    <h5>{item.username_usr + " | " + moment(item.fchsstm_cmntrfr).format('dddd,Do MMMM YYYY LT')}</h5>
                    <p>
                      {item.cmntr_cmntrfr}
                    </p>
                  </div>
                </div>
              ))) : ('')}
            </div>
          ) : ('')}
        </div>
        {isAuth ? (
          <div className="form">
            <form onSubmit={handleSubmit}>
              <textarea value={mensaje} onChange={(e) => setMensaje(e.target.value)} placeholder="Escribe tu mensaje" name="input_text" id="input_text" rows="3"></textarea>
              <button type="submit" className="btn_cntct">Publicar Comentario</button>
            </form>
          </div>
        ) : (
          <p className="text_session">Debes iniciar sesión para participar con tu opinión.</p>
        )}
        <div className="socialshare">
          <SocialShare
              title={foro.ttlo_fro}
              text={foro.dscrpcn_fro}
              url={"http://radioital.com/comunidad/"+foro.key_fro}
              instagramUser={"radioitalofficial"}
            />
        </div>
      </div>
    </>
    )
  }
};

export default Foro;